import {Injectable} from '@angular/core';
import {distinctUntilChanged, filter, map, switchMap} from 'rxjs/operators';
import {ConfiguratorRouter, ConfiguratorRouterExtractorService} from '@spartacus/product-configurator/common';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Observable} from 'rxjs';
import {ConfiguratorCommonsService} from '@spartacus/product-configurator/rulebased';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class StepInputService {
  public isStepInputDisabled$: Observable<boolean | null>;

  constructor(
    protected configRouterExtractorService: ConfiguratorRouterExtractorService,
    protected configCommonsService: ConfiguratorCommonsService,
  ) {
    this.isStepInputDisabled$ = this.configRouterExtractorService.extractRouterData().pipe(
      distinctUntilChanged(),
      filter((routerData) => routerData.pageType === ConfiguratorRouter.PageType.CONFIGURATION),
      switchMap((routerData) => this.configCommonsService.hasPendingChanges(routerData.owner)),
      map((pendingChanges) => pendingChanges || null),
      untilDestroyed(this),
    );
  }
}
